function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 12,
  fill: "#5CAA5B",
  stroke: "#F8FAFE",
  strokeWidth: 2
});

function SvgRemoveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translate(calc(50% - 4.5px), calc(50% - 4px))"
    },
    fillRule: "evenodd",
    top: 5,
    clipRule: "evenodd",
    d: "M0.690381 0.190381C0.944221 -0.0634602 1.35578 -0.0634602 1.60962 0.190381L4.9 3.48076L8.19038 0.190381C8.44422 -0.0634602 8.85578 -0.0634602 9.10962 0.190381C9.36346 0.444221 9.36346 0.855779 9.10962 1.10962L5.81924 4.4L9.10962 7.69038C9.36346 7.94422 9.36346 8.35578 9.10962 8.60962C8.85578 8.86346 8.44422 8.86346 8.19038 8.60962L4.9 5.31924L1.60962 8.60962C1.35578 8.86346 0.944221 8.86346 0.690381 8.60962C0.43654 8.35578 0.43654 7.94422 0.690381 7.69038L3.98076 4.4L0.690381 1.10962C0.43654 0.855779 0.43654 0.444221 0.690381 0.190381Z",
    fill: "#F8FAFE"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/RemoveIcon.b1badc8e.svg";
export { ForwardRef as ReactComponent };